import React, { useEffect, useState } from 'react';
import LandingHeader from './00-shared/LandingHeader';
import LandingFooter from './00-shared/LandingFooter';
import { GlobalStyles } from './00-shared/styles';
import { highlightColor } from './00-shared/constants';
import HeroSection from './10-home/10-HeroSection';
import ValuePropositionSection from './10-home/11-ValuePropositionSection';
import PartnershipSection from './10-home/12-PartnershipSection';
import WhyPartnerSection from './10-home/13-WhyPartnerSection';
// import SuccessStoriesSection from './10-home/15-SuccessStoriesSection';
// import AwardsSection from './10-home/16-AwardsSection';
// import ArticlesSection from './10-home/17-ArticlesSection';
import NewsModal from './10-home/18-NewsModal';
import ReadySection from './10-home/14-ReadySection';


const Landing: React.FC = () => {
    const [showNewsModal, setShowNewsModal] = useState(false);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        const observerOptions = {
            threshold: 0.1,
            rootMargin: '0px 0px -100px 0px'
        };

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('fade-in-up');
                }
            });
        }, observerOptions);

        document.querySelectorAll('.observe-fade').forEach(el => observer.observe(el));

        return () => observer.disconnect();
    }, []);

    return (
        <div className="min-h-screen bg-black text-white transition-colors duration-300" style={{ fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif" }}>
            <GlobalStyles />
            <LandingHeader highlightColor={highlightColor} />
            <HeroSection 
                highlightColor={highlightColor} 
                onNewsClick={() => setShowNewsModal(true)} 
            />
            <ValuePropositionSection highlightColor={highlightColor} />
            <PartnershipSection highlightColor={highlightColor} />
            <WhyPartnerSection highlightColor={highlightColor} />
            <ReadySection highlightColor={highlightColor} />
            {/* <SuccessStoriesSection />
            <AwardsSection highlightColor={highlightColor} />
            <ArticlesSection /> */}
            <LandingFooter highlightColor={highlightColor} />
            <NewsModal 
                show={showNewsModal} 
                onClose={() => setShowNewsModal(false)} 
            />
        </div>
    );
};

export default Landing;

